import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { RemoteHttpService } from '../../remote-http';
import { Custom_RequestMethod } from '../common-service';
import { ContentType, RemoteRequest } from '../../remote-request';
import * as global from '../../globals';
import { PagedData } from 'src/data/mygolf.data';
import { JsonService } from 'src/json-util';
import { SessionInfo } from 'src/data/authentication-info';
import axios from 'axios';
@Injectable({
  providedIn: 'root',
})
export class HotelService {
  constructor(
    private http: RemoteHttpService,
    private requestMethod: Custom_RequestMethod
  ) {}

  createNewHotel(params: any): Observable<any> {
    let _params = params;
    let url = global.ServerUrls.hotel.createNewHotel;
    let request = new RemoteRequest(
      url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateHotel(params: any, HotelId: number): Observable<any> {
    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;
    // let reDayId = /:dayId/gi;

    let url = global.ServerUrls.hotel.updateHotel;
    url = url.replace(reClosureId, _HotelId);
    let _params = params;
    let request = new RemoteRequest(
      url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public searchHotel(search?: string, pageSize?: number, pageNo?: number,countryId?:string) {
    console.debug("searching hotel : ", search, pageSize, pageNo, countryId)
    let _params = {};
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    if (search) _params['search'] = search;
    if(!countryId || countryId === undefined) {
      delete _params['country'];
    } else {

    if (countryId) _params['country'] = countryId;
    }
    let request = new RemoteRequest(
      global.ServerUrls.hotel.searchHotel,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
      // {
      //   pageNo: _params['pageNo'],
      //   pageSize: _params['pageSize'],
      //   search: _params['search'],
      //   country :  _params['country']
      // }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let hotelList: PagedData<any> = resp;
          hotelList.items.forEach((tb: any) => {
            if (tb.hotelImages)
              JsonService.deriveFullImageUrlArrayObject(tb.hotelImages);
            if (tb?.rooms) {
              tb?.rooms.forEach((x: any) => {
                JsonService.deriveFullImageUrlArrayObject(x.roomImages);
              });
            }
          });
          return hotelList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteHotel(HotelId: number): Observable<any> {
    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;
    // let reDayId = /:dayId/gi;

    let url = global.ServerUrls.hotel.deleteHotel;
    url = url.replace(reClosureId, _HotelId);
    let request = new RemoteRequest(
      url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  getHotelById(HotelId: number): Observable<any> {
    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;
    // let reDayId = /:dayId/gi;

    let url = global.ServerUrls.hotel.getHotelById;
    url = url.replace(reClosureId, _HotelId);
    let request = new RemoteRequest(
      url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          if (resp && resp?.rooms) {
            JsonService.deriveFullImageUrlArrayObject(resp.hotelImages);
            resp?.rooms.forEach((tb: any) => {
              JsonService.deriveFullImageUrlArrayObject(tb.roomImages);
            });
          }
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteHotelImage(HotelId, imageUrl) {
    let imgURL = JsonService.removeServerURL(imageUrl);

    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;
    let url = global.ServerUrls.hotel.deleteHotelImage;
    url = url.replace(reClosureId, _HotelId);
    url += `/?imageUrl=${imgURL}`;
    let request = new RemoteRequest(
      url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  multipalHotelImageUpload(
    selectedFiles: any,
    HotelId,
    userDetails: SessionInfo
  ) {
    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;
    let url = global.ServerUrls.hotel.AddHotelImage;
    url = url.replace(reClosureId, _HotelId);
    return new Promise((resolve, reject) => {
      const formData: FormData = new FormData();

      for (let I = 0; I < selectedFiles.length; I++) {
        const element = selectedFiles[I];
        formData.append('imageFiles ', element);
      }

      axios
        .post(url, formData, {
          auth: {
            username: userDetails.user.userName,
            password: userDetails.user.password,
          },
        })
        .then(function (response) {
          resolve(response);
        });
    });
  }

  createNewHotelRoom(HotelId, params: any): Observable<any> {
    let _params = params;
    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;
    let url = global.ServerUrls.hotel.createNewHotelRooms;
    url = url.replace(reClosureId, _HotelId);
    let request = new RemoteRequest(
      url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateHotelRoom(HotelId, roomId, params: any): Observable<any> {
    let _params = params;
    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;
    let _RoomId = roomId;
    let reRoomId = /:roomId/gi;
    let url = global.ServerUrls.hotel.updateHotelRooms;
    url = url.replace(reClosureId, _HotelId);
    url = url.replace(reRoomId, _RoomId);
    let request = new RemoteRequest(
      url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteHotelRoom(HotelId: number, roomId): Observable<any> {
    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;

    let _RoomId = roomId;
    let reRoomId = /:roomId/gi;

    let url = global.ServerUrls.hotel.deleteHotelRooms;
    url = url.replace(reClosureId, _HotelId);
    url = url.replace(reRoomId, _RoomId);
    let request = new RemoteRequest(
      url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  multipalHotelRoomImageUpload(
    selectedFiles: any,
    HotelId,
    roomId,
    userDetails: SessionInfo
  ) {
    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;

    let _RoomId = roomId;
    let reRoomId = /:roomId/gi;

    let url = global.ServerUrls.hotel.createHotelRoomImage;
    url = url.replace(reClosureId, _HotelId);
    url = url.replace(reRoomId, _RoomId);
    return new Promise((resolve, reject) => {
      const formData: FormData = new FormData();

      for (let I = 0; I < selectedFiles.length; I++) {
        const element = selectedFiles[I];
        formData.append('imageFiles ', element);
      }

      axios
        .post(url, formData, {
          auth: {
            username: userDetails.user.userName,
            password: userDetails.user.password,
          },
        })
        .then(function (response) {
          resolve(response);
        });
    });
  }

  deleteHotelRoomImage(HotelId, roomId, imageUrl) {
    let imgURL = JsonService.removeServerURL(imageUrl);
    let _HotelId = HotelId;
    let reClosureId = /:Id/gi;

    let _RoomId = roomId;
    let reRoomId = /:roomId/gi;

    let url = global.ServerUrls.hotel.deleteHotelRoomImage;
    url = url.replace(reClosureId, _HotelId);
    url = url.replace(reRoomId, _RoomId);
    url += `/?imageUrl=${imgURL}`;
    let request = new RemoteRequest(
      url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
}
